function wireUpEventHandler(handlerName, handlerParam) {
    if (handlerParam) {
        return handlerParam
    }

    return () => {
        throw Error(
            `No ${handlerName} handler provided and no Connector provided. You must configure one or the other.`,
        )
    }
}

/*
 * This class encapsulates the logic for Events. Events are events that occur
 * within Search UI that require integration with an external service to
 * either fetch / search for data, or notify analytics services of interesting
 * events that occur within a UI.
 *
 * Handlers for these events can either be passed directly, or by providing
 * an API Connector.
 */
export default class Events {
    constructor({ onSearch, onAutocomplete } = {}) {
        this.search = wireUpEventHandler('onSearch', onSearch)
        this.autocomplete = wireUpEventHandler('onAutocomplete', onAutocomplete)
    }
}
